<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide'
import Content from '~/components/Common/Content.vue'
import PageHeader from '~/components/Product/LandingPages/PageHeader.vue'
import UspItem from '~/components/Product/LandingPages/UspItem.vue'
import CardList from '~/components/Product/LandingPages/CardList.vue'
import Offer from '~/components/Product/LandingPages/Offer.vue'
import Faqs from '~/components/Product/LandingPages/Faqs.vue'
import Accordion from '~/components/Product/LandingPages/Accordion.vue'

import headerImage from '~/public/images/products/trimtone/trimtone-product.webp'
import flame from '~/public/images/products/trimtone/trimtone-flame.png'
import knifeFork from '~/public/images/products/trimtone/trimtone-knife-fork.png'
import leafs from '~/public/images/products/trimtone/trimtone-leafs.png'
import metabolism from '~/public/images/products/trimtone/trimtone-metabolism.png'
import payments from '~/public/images/products/trimtone/trimtone-payments.webp'

import testimonialOnePhoto from '~/public/images/products/trimtone/testimonial-1-photo.avif'
import testimonialOneThumbnail from '~/public/images/products/trimtone/testimonial-1-thumbnail.webp'
import testimonialOneUser from '~/public/images/products/trimtone/testimonial-1-user.webp'
import testimonialOneVideo from '~/public/images/products/trimtone/testimonial-1-video.mp4'

import testimonialTwoPhoto from '~/public/images/products/trimtone/testimonial-2-photo.webp'
import testimonialTwoThumbnail from '~/public/images/products/trimtone/testimonial-2-thumbnail.webp'
import testimonialTwoUser from '~/public/images/products/trimtone/testimonial-2-user.webp'
import testimonialTwoVideo from '~/public/images/products/trimtone/testimonial-2-video.mov'

import testimonialThreeUser from '~/public/images/products/trimtone/testimonial-3-user.webp'
import testimonialFourUser from '~/public/images/products/trimtone/testimonial-4-user.webp'
import testimonialFiveUser from '~/public/images/products/trimtone/testimonial-5-user.webp'

import contentBlockOne from '~/public/images/products/trimtone/content-block-1.avif'
import contentBlockTwo from '~/public/images/products/trimtone/content-block-2.avif'
import contentBlockThree from '~/public/images/products/trimtone/content-block-3.webp'
import contentBlockFour from '~/public/images/products/trimtone/content-block-4.webp'

import ingredientOne from '~/public/images/products/trimtone/ingredient-1.webp'
import ingredientTwo from '~/public/images/products/trimtone/ingredient-2.webp'
import ingredientThree from '~/public/images/products/trimtone/ingredient-3.webp'
import ingredientFour from '~/public/images/products/trimtone/ingredient-4.webp'
import ingredientFive from '~/public/images/products/trimtone/ingredient-5.avif'

import ingredientList from '~/public/images/products/trimtone/ingredient-list.webp'

import fiveStars from '~/public/images/products/trimtone/5-stars.png'
import fourAndHalfStars from '~/public/images/products/trimtone/4-5-stars.png'
import paymentMethods from '~/public/images/products/trimtone/payment-methods.webp'
import offerPage from '~/public/images/products/trimtone/offer-page.webp'

const showVideo = ref()
</script>

<template>
	<Content>
		<PageHeader
			button-text="Buy Now"
			button-link="#checkout"
			:main-image="headerImage"
			background="#f7e3eb"
			paragraph="Achieve your body goals faster with 24/7 fat burning fuelled by nature"
			sub-text="Rated Great (700+ reviews)"
			:bottom-image="payments"
			:icons="[
				{ icon: flame, title: 'Burns fat' },
				{ icon: knifeFork, title: 'Reduces appetite' },
				{ icon: metabolism, title: 'Boosts your metabolism' },
				{ icon: leafs, title: '100% Natural Ingredients' },
			]"
			item-size="l"
			icon-direction="column"
			icon-size="m">
			<template #header>
				<h1 class="text-color text-5xl md:text-7xl md:text-balance uppercase">
					100% Natural <span class="text-highlight">FEMALE Fat Burner</span>
				</h1>
			</template>
		</PageHeader>

		<div class="bg-[#261754]">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<h2 class="text-3xl md:text-5xl text-white text-center mb-8 md:mb-12">
					Erica & Katie on using Trimtone to<br />
					manage cravings & boost energy.
				</h2>

				<div class="grid md:grid-cols-2 items-start gap-8">
					<div
						v-for="(testimonial, index) in [
							{
								thumbnail: testimonialOneThumbnail,
								video: testimonialOneVideo,
								user: {
									image: testimonialOneUser,
									name: 'Erica',
									location: 'United States',
								},
								quote: `I am quite pleased with the product and have noticed a difference of 11 lbs so far, faster than I anticipated. I plan to keep using Trimtone to maintain my progress and to support my energy levels throughout the day.<br /><br />
								Thank you,<br />
								Erica`,
								image: testimonialOnePhoto,
							},
							{
								thumbnail: testimonialTwoThumbnail,
								video: testimonialTwoVideo,
								user: {
									image: testimonialTwoUser,
									name: 'Katie',
									location: 'United States',
								},
								quote: `I love Trimtone, I will continue to spread the word on how amazing this product is. My name is Katie. I’m 34 years old have 4 children and that has done a number to my body.<br /><br />
								I needed something to help me with both energy and cravings…boy, did I ever find the perfect product in Trimtone! I started taking Trimtone in September, by the time I got to February I saw a change of over 30lbs<br /><br />
								<strong>I am a 100% satisfied customer.</strong>`,
								image: testimonialTwoPhoto,
							},
						]"
						class="p-2 bg-white rounded-xl"
					>
						<div class="flex flex-col">
							<div class="relative mb-2">
								<img
									:src="testimonial.thumbnail"
									alt="Testimonial Thumbnail"
									class="w-full"
									:class="{
										'opacity-0 pointer-events-none': showVideo === index,
										'opacity-100 pointer-events-auto': showVideo !== index,
									}"
									@click="showVideo = index"
								/>
								<video
									v-if="showVideo === index"
									:src="testimonial.video"
									controls
									autoplay
									class="absolute top-0 left-0 w-full h-full"
								></video>
							</div>
							<div class="flex items-center mb-4">
								<img
									:src="testimonial.user.image"
									:alt="`Image of ${testimonial.user.name}`"
									class="w-16 h-16 rounded-full mr-4"
								/>
								<div>
									<p class="!text-base md:!text-xl font-bold text-black my-0">
										{{ testimonial.user.name }}
									</p>
									<p class="!text-base md:!text-lg text-black my-0">
										{{ testimonial.user.location }}
									</p>
								</div>
							</div>
							<p class="!text-base md:!text-xl" v-html="testimonial.quote"></p>

							<img
								:src="testimonial.image"
								alt="Testimonial Image"
								class="w-full h-auto rounded-lg"
							/>
						</div>
					</div>
				</div>

				<a
					class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center max-w-full w-60 mt-8 mx-auto"
					href="#checkout">
					Buy Now
					<Icon name="ph:caret-right-bold" />
				</a>
			</div>
		</div>

		<div class="bg-[#f7e6ed]">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<div class="grid md:grid-cols-3 gap-8 mb-16">
					<div
						v-for="(testimonial, index) in [
							{
								user: {
									image: testimonialThreeUser,
									name: 'Beth M',
								},
								quote: 'As a mom of a 2-year-old, Trimtone has been a great fit for my busy schedule. I would recommend it to anyone who needs a little boost in their wellness journey.',
							},
							{
								user: {
									image: testimonialFourUser,
									name: 'Cynthia S',
								},
								quote: 'I was pleasantly surprised by Trimtone\'s supportive role in my fasting routine and evening workouts. It\'s one of the most helpful wellness supplements I\'ve ever used.',
							},
							{
								user: {
									image: testimonialFiveUser,
									name: 'A S. Bujalski, Psy.D',
								},
								quote: 'Trimtone has played a role in my wellness journey by supporting my metabolism and giving me energy. I highly recommend this product, I can\'t wait for my next bottle.',
							},
						]"
						:key="index"
						class="p-4 bg-white rounded-xl border border-[#e1e8ed]"
					>
						<div class="flex items-center mb-4">
							<img
								:src="testimonial.user.image"
								:alt="`Image of ${testimonial.user.name}`"
								class="w-16 h-16 rounded-full mr-4"
							/>
							<div>
								<p class="!text-base md:!text-xl font-medium text-black mt-0 mb-1">
									{{ testimonial.user.name }}
								</p>

								<img class="h-4" :src="fiveStars" />
							</div>
						</div>
						<p class="!text-base md:!text-lg" v-html="testimonial.quote"></p>
					</div>
				</div>

				<h2 class="text-3xl md:text-5xl text-center font-semibold text-color mb-4">
					Trimtone tells your body to <span class="text-highlight">burn more calories, fires up fat loss</span> and helps you slay your health and fitness goals
				</h2>

				<p class="!text-base md:!text-xl text-center">Supports your wellness and fitness goals</p>

				<div class="grid md:grid-cols-[4fr,1fr] gap-12 my-12">
					<div class="bg-white p-4 rounded-xl">
						<h3 class="text-3xl font-medium text-center text-highlight">
							Burn stubborn body fat and unlock your body confidence
						</h3>

						<p class="!text-base md:!text-lg">
							Trimtone stimulates thermogenesis – the conversion of stored fat into energy – and speeds up your metabolism – the amount of calories you naturally burn, even while at rest. It literally tells your body to burn fat.<br /><br />
							You’ll burn through even the most stubborn stored fat round-the-clock, helping you lose weight and reach your body goals quicker. Burn baby burn!
						</p>
					</div>

					<img
						class="rounded-xl w-full h-full"
						:src="contentBlockOne"
					/>
				</div>

				<div class="grid md:grid-cols-[1fr,4fr] gap-12">
					<img
						class="rounded-xl w-full h-full"
						:src="contentBlockTwo"
					/>

					<div class="bg-white p-4 rounded-xl">
						<h3 class="text-3xl font-medium text-center text-highlight">
							Curb cravings and stay on track with your goals
						</h3>

						<p class="!text-base md:!text-lg">
							Nothing derails all your good progress like a snack-attack. Trimtone suppresses your appetite and reduces pesky hunger cravings, helping you keep your daily calorie intake in check.<br /><br />
							By helping you stay in control of your eating, Trimtone helps you say no to unnecessary calories that’d otherwise end up on your waistline. Not today, brownie!
						</p>
					</div>
				</div>
			</div>
		</div>

		<div class="bg-white">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<div class="grid md:grid-cols-[3fr,2fr] gap-8 md:gap-12 items-start">
					<div>
						<h2 class="text-3xl md:text-5xl font-semibold text-color mb-4">
							One-a-day formula <span class="text-highlight">designed for real women</span> who don’t have time to mess around
						</h2>

						<p class="!text-base md:!text-xl mb-8">
							Let’s be real. In between running from work to the gym to the grocery store, managing your mile-long to-do list and worrying about whether it’s hair wash day, you don’t need extra hassle in your life.<br /><br />
							Which is why we made Trimtone totally faff-free and super easy to use. Just take one capsule a day. That’s it.
						</p>

						<a
							class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center max-w-full w-60 mt-8"
							href="#checkout">
							Buy Now
							<Icon name="ph:caret-right-bold" />
						</a>

						<div class="flex gap-2 mt-4 items-center">
							<img class="h-5" :src="fourAndHalfStars" />
							<p class="!text-base text-color my-0">
								Rated Great (700+ reviews)
							</p>
						</div>
						<img class="mt-4" :src="paymentMethods" />
					</div>

					<img
						class="rounded-xl w-full"
						:src="contentBlockThree"
					/>
				</div>

				<div class="grid md:grid-cols-3 gap-8 mt-12">
					<div
						v-for="(item, index) in [
							{
								icon: 'ph:pill',
								text: '1 Capsule per Day',
							},
							{
								icon: 'ph:clock',
								text: 'Before Breakfast',
							},
							{
								icon: 'ph:drop',
								text: 'Take with water',
							},
						]"
						class="bg-[#f7e6ee] py-8 px-4 rounded-xl"
					>
						<UspItem
							direction="column"
							:icon="item.icon"
							:title="item.text"
							icon-color="text-highlight"
							text-color="text-color"
							text-size="lg"
						/>
					</div>
				</div>
			</div>
		</div>

		<CardList
			type="loop"
			:items="[
				{
					image: ingredientOne,
					title: 'Caffeine',
					text: 'Who doesn’t appreciate a dose of caffeine? Caffeine is known to help increase thermogenesis[1] and lipolysis[2]. It is known to help enhance performance, making your workouts more efficient. Moreover, as a stimulant, it’ll provide an instant boost of energy and alertness.',
					studies:
						'A single 100mg dose of caffeine (around the same amount you’ll get in Trimtone) can potentially increase resting metabolic rate by up to 3-4%[3]<br />Reviews of multiple trials and studies indicate that caffeine can support weight, BMI, and body fat management and potentially improve exercise performance by up to 11.2%[5]',
				},
				{
					image: ingredientTwo,
					title: 'Green Coffee',
					text: 'Green coffee beans are raw, unroasted coffee beans containing substances like chlorogenic acid, which are typically lost during the roasting process. Chlorogenic acid is believed to influence the amount of fat and glucose absorbed by your gut when you eat6, potentially improving your metabolism.',
					studies: 'In one study, women taking 400mg of green coffee extract for 8 weeks along with a calorie-restricted diet had a larger weight difference (4.84 kg) compared to those taking a placebo (2.62kg)[7].<br />A review of several studies concluded that people taking green coffee bean extract had a notable change in their weight compared to those taking a placebo[8].',
				},
				{
					image: ingredientThree,
					title: 'Green Tea',
					text: 'Green tea contains compounds believed to help increase metabolism and levels of hormones that influence fat cell behavior\'. Research suggests that catechins in green tea may affect the.',
					studies: 'Participants taking a daily green tea-caffeine mixture during a 4-month study saw a greater. A review of multiple studies concluded that catechins in green tea have a significant impact on body weight and help maintain body weight following weight loss12.',
				},
				{
					image: ingredientFour,
					title: 'Grains of Paradise',
					text: 'Studies suggest that Grains of Paradise (a herb from the ginger family) can stimulate brown adipose tissue[13] (BAT), which is involved in calorie burning. The activation of BAT may also help regulate blood sugar levels.',
					studies: 'Women taking 30mg grains of paradise extract daily for 4 weeks saw a significant change in abdominal fat compared to those taking a placebo14. Trimtone provides a daily dose of 40mg!',
				},
				{
					image: ingredientFive,
					title: 'Glucomannan',
					text: 'Research shows that this dietary fiber can make a meaningful contribution to weight management. It expands in your stomach, helping you feel fuller for longer, potentially reducing the tendency to overeat.',
					studies: 'Participants taking glucomannan as a food supplement had a 5.5lbs difference over an 8 week period without making any other changes to their diet or exercise habits[15].<br /><br />In another study, participants taking a glucomannan and psyllium husk combination felt more full after eating and had a notable weight difference over 16 weeks compared to those taking a placebo[16].',
				},
			]"
			:slider="true"
			:per-page="1"
			background="bg-[#f7e6ee]">
			<template #header>
				<h2 class="text-3xl md:text-4xl font-semibold text-color text-start mb-4">
					Made with only the most <span class="text-highlight">effective, natural ingredients</span> to quickly and safely fuel your weight loss
				</h2>

				<p class="!text-base md:!text-lg text-start my-0">
					Trimtone contains only the good stuff straight from mother nature. No fillers, no fake-stuff, and absolutely, positively no nasties. What you see is what you get.<br /><br />
					And unlike some other fat burners for women, it isn’t overloaded with any unnecessary ingredients. Our formula may look simple, but it packs a powerful punch. Each capsule is fully loaded with only the necessary, proven ingredients you need to support your goals and deliver results.<br /><br />
					<strong>It’s simple. But effective.</strong>
				</p>
			</template>

			<template #slides="{ items }">
				<SplideSlide
					v-for="(item, index) in items"
					:key="index"
					class="flex flex-col items-center md:flex-row gap-4 md:gap-8 bg-[#261753] p-8 rounded-2xl">
					<img class="h-fit max-w-full md:w-80 rounded-xl" :src="item.image" />
					<div class="h-full">
						<h3 class="text-3xl font-semibold text-highlight text-start mb-2">
							{{ item.title }}
						</h3>

						<p class="!text-base md:!text-lg text-start text-white mb-4">
							{{ item.text }}
						</p>

						<p class="!text-2xl font-semibold text-white text-start mb-2">
							Checkout out the studies:
						</p>

						<p class="!text-base md:!text-lg text-start text-white mb-0" v-html="item.studies"></p>
					</div>
				</SplideSlide>
			</template>
		</CardList>

		<div class="bg-white">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<div class="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
					<img
						class="rounded-xl w-full"
						:src="contentBlockFour"
					/>

					<div>
						<h2 class="text-3xl md:text-4xl font-semibold text-color mb-4">
							Your 100 day <span class="text-highlight">”hell yeah it really works!”</span> money back guarantee
						</h2>

						<p class="!text-base md:!text-xl mb-8">
							But does it really work?” You betcha! Which is why we’re giving you the absolute best and longest guarantee on the market!<br /><br />
							Whether you need to kickstart your weight loss or you’re looking for long-term weight maintenance, Trimtone will help you reach your goals and achieve your best body – whatever that means to you.
						</p>

						<p class="!text-base text-highlight">
							Trimtone works. But if, after taking it as directed alongside a suitable diet and exercise program for at least 50 days, you don’t believe Trimtone is supporting your weight loss efforts, simply email us within 50-100 days of receiving your order and we promise to refund your money, excluding a $15 fixed fee to cover shipping and admin costs*.<br /><br />
							Terms and conditions apply. Guarantee applies to purchases of over one month's supply and only on first purchase. Click here to read the full terms of our refund policy.
						</p>

						<a
							class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center max-w-full w-60 mt-8"
							href="#checkout">
							Buy Now
							<Icon name="ph:caret-right-bold" />
						</a>

						<div class="flex gap-2 mt-4 items-center">
							<img class="h-5" :src="fourAndHalfStars" />
							<p class="!text-base text-color my-0">
								Rated Great (700+ reviews)
							</p>
						</div>
						<img class="mt-4" :src="paymentMethods" />
					</div>
				</div>

				<div class="grid md:grid-cols-4 gap-8 mt-12">
					<div
						v-for="(item, index) in [
							{
								icon: 'ph:currency-circle-dollar',
								text: 'Money Back Guarantee',
							},
							{
								icon: 'ph:truck',
								text: 'Free Delivery',
							},
							{
								icon: 'ph:certificate',
								text: 'GMP Certified',
							},
							{
								icon: 'ph:flag',
								text: 'Made in The USA',
							},
						]"
						class="bg-[#f7e6ee] py-8 px-4 rounded-xl"
					>
						<UspItem
							direction="column"
							:icon="item.icon"
							:title="item.text"
							icon-color="text-highlight"
							text-color="text-color"
							text-size="lg"
						/>
					</div>
				</div>
			</div>
		</div>
		<Offer
			header="Select your Trimtone options"
			product-title="TRIMTONE - FEMALE FAT BURNER"
			rated-text="Rated Great (700+ reviews)"
			product-description="Achieve your body goals faster with 24/7 fat burning fuelled by nature"
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ0NjMwMTg2MDY5MDEsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA2OTAzNDY4ODU0MjksICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA3ODEzMzc1NjIxM31dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/44463018606901:1?channel=buy_button"
			:subscribe-price="31.99"
			:discounted-price="39.99"
			:original-price="59.99"
			background="bg-[#F8E3E9]"
			:product-image="offerPage" />

		<Faqs
			header="Frequently asked questions"
			background="#F8E3E9"
			item-background="#ffffff"
		>
			<template #items>
				<Accordion
					v-for="(item, index) in [
						{
							heading: 'Does it work?',
							text: 'Certainly! Trimtone features ingredients like caffeine, green tea extract, and grains of paradise. Many research studies indicate their potential roles in supporting weight loss.',
						},
						{
							heading: 'Do I have to diet and exercise?',
							text: `Yes! Trimtone is not a magical solution that will remove fat without any effort. It can potentially enhance your body’s calorie-burning process and support fat burning, which may assist you in weight loss. But reaching your goals usually involves a healthy diet and regular physical activity. If you’re not planning on embracing a healthy lifestyle, Trimtone – or any other weight loss supplement – may not be the right fit.`,
						},
						{
							heading: 'How do I take Trimtone?',
							text: `We recommend you take one Trimtone capsule each morning with 8oz of water 30mins before your breakfast. Most other fat burner supplements require you to take them several times throughout the day. But who’s got time to remember that? We’ve made Trimtone super easy for you to use so you can get on with your life and focus on what’s important.`,
						},
						{
							heading: 'Can I use it as a pre-workout?',
							text: `Absolutely! Trimtone contains caffeine, the most famous stimulant and thermogenic fat burner there is. Which makes it a great pre-workout, especially if you train in the morning. If you train in the evening though, we don’t recommend you use it as a pre-workout. Because, caffeine.`,
						},
						{
							heading: 'How fast will I see results?',
							text: `Outcomes can vary between individuals and will likely depend on your diet and exercise routine. Many of our customers who use Trimtone in combination with a healthy diet and consistent exercise have reported noticing changes within several weeks.`,
						},
						{
							heading: 'How long will one bottle last?',
							text: `Each bottle of Trimtone contains 30 capsules, which will last you for 30 days.`,
						},
						{
							heading: 'What’s in Trimtone?',
							text: `
								Trimtone contains a number of recognized and proven ingredients designed to help support your weight loss so you can achieve your best body. The Trimtone formula is all-natural and contains no harmful ingredients, chemicals or fillers.
								<img class='mt-4' src='${ingredientList}' />
							`,
						},
						{
							heading: 'Are there any side effects?',
							text: `Trimtone is composed of 100% natural ingredients, which are generally considered safe with no known adverse effects. However, Trimtone does contain 120mg of caffeine per daily dose (about one cup of coffee) along with 100mg of green coffee and 100mg of green tea. If you have a sensitivity to caffeine or stimulants, it might be wise to adjust your consumption of caffeinated drinks while using Trimtone.`,
						},
						{
							heading: 'Is Trimtone suitable for vegetarians and vegans?',
							text: `We’re sorry but currently Trimtone is made using a gelatin capsule, making it unsuitable for vegetarians or vegans`,
						},
						{
							heading: 'Can I use it if I’m pregnant, breastfeeding or on medication?',
							text: `We advise against using Trimtone if you are pregnant or breastfeeding. If you are taking medication, it’s essential to consult with a healthcare professional before starting Trimtone to ensure it’s appropriate for you.`,
						},
						{
							heading: 'What’s the deal with shipping?',
							text: `Shipping is FREE when you order to USA, UK or Canada.`,
						},
					]"
					:key="index"
					:heading="item.heading"
					:text="item.text"
					background="#ffffff"
					heading-color="text-[#e7569c]"
				/>
			</template>
			<template #footer>
				<div class="flex flex-col items-center">
					<a
						class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center max-w-full w-60 mt-8"
						href="#checkout">
						Buy Now
						<Icon name="ph:caret-right-bold" />
					</a>

					<div class="flex gap-2 mt-4 items-center">
						<img class="h-5" :src="fourAndHalfStars" />
						<p class="!text-base text-color my-0">
							Rated Great (700+ reviews)
						</p>
					</div>
					<img class="mt-4" :src="paymentMethods" />
				</div>
			</template>
		</Faqs>

		<div class="bg-white">
			<div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<h2 class="text-3xl md:text-4xl font-semibold text-color text-center mb-4">
					Clinical References:
				</h2>

				<ol class="list-decimal">
					<li
						class="list-decimal text-color"
						v-for="item in [
							'Astrup, A., Toubro, S., Cannon, S., Hein, P., Breum, L. & Madsen, J. (1990): ‘Caffeine: a double-blind, placebo-controlled study of its thermogenic, metabolic, and cardiovascular effects in healthy volunteers’. American Journal of Clinical Nutrition, 1990 May;51(5):759-67. PMID: 2333832',
							'Kobayashi-Hattori, K., Mogi, A., Matsumoto, Y. & Takita, T. (2005): ‘Effect of caffeine on the body fat and lipid metabolism of rats fed on a high-fat diet’. Bioscience, biotechnology, and Biochemistry, 2005 Nov;69(11):2219-2',
							'PMID 163067063. Dulloo, A., Geissler, A.C., Horton, T., Collins, A. & Miller, D.S. (1989): ‘Normal caffeine consumption: influence on thermogenesis and daily energy expenditure in lean and postobese human volunteers’. American Journal of Clinical Nutrition, 1989 Jan;49(1):44-50. PMID 2912010',
							'Tabrizi, R., Saneei, P., Lankarani, K.B., Akbari, M., Kolahdooz, F., Esmaillzadeh, A., Nadi-Ravandi, S., Mazoochi, M. & Asemi, Z. (2019): ‘The effects of caffeine intake on weight loss: a systematic review and dos-response meta-analysis of randomized controlled trials’. Critical Reviews in Food Science and Nutrition, 2019;59(16):2688-2696. PMID 30335479',
							'Doherty, M. & Smith, P.M. (2005): ‘Effects of caffeine ingestion on rating of perceived exertion during and after exercise: a meta‐analysis’. Scandinavian Journal of Medicine & Science in Sports, 005 Apr;15(2):69-78. PMID 15773860',
							'Meng, S., Cao, J., Feng, Q., Peng, J. & Hu, Y. (2013): ‘Roles of Chlorogenic Acid on Regulating Glucose and Lipids Metabolism: A Review’. Evidence-Based Complementary and Alternative Medicine, 2013; 2013: 801457.',
							'Haidari, F., Samadi, M., Mohammadshahi, M., Jalali, M.T. & Engali, K.A. (2017): ‘Energy restriction combined with green coffee bean extract affects serum adipocytokines and the body composition in obese women’. Asia Pacific Journal of Clinical Nutrition, 2017; 26(6):1048-1054',
							'Onakpoya, I., Terry, R. & Ernst, E. (2011): ‘The Use of Green Coffee Extract as a Weight Loss Supplement: A Systematic Review and Meta-Analysis of Randomised Clinical Trials’. Gastroenterology Research and Practice, 2011; 2011: 382852. PMCID: 2943088',
							'Westerterp-Plantenga, M.S. (2010): ‘Green tea catechins, caffeine and body-weight regulation’. Physiology & Behaviour, 2010, Apr 26;100(1):42-6',
							'Lochocka, K., Bajerska, J., Glapa, A., Fiddler-Witon, A., Nowak, J.K., Szczapa, T., Grebowiec, P., Lisowska, A. & Walkowiak, J. (2015): ‘Green tea extract decreases starch digestion and absorption from a test meal in humans: a randomized, placebo-controlled crossover study’. Scientific Reports, 2015 Jul 30;5:12015. PMCID 4520190',
							'Westerterp-Plantenga, M.S., Lejeune, M.P.G.M. & Kovacs, E.M.R. (2005): ‘Body weight loss and weight maintenance in relation to habitual caffeine intake and green tea supplementation’. Obesity Research, 2005 13(7):1195-204. PMID 16076989',
							'Hursel, R., Viechtbauer, W. & Westerterp-Plantega, M. (2009): ‘The effects of green tea on weight loss and weight maintenance: a meta-analysis’. International Journal of Obesity, 2009 33(9):956-61',
							'Sugita, J., Yoneshiro, T., Hatano, T., Aita, S., Ikemoto, T., Uchiwa, H., Iwanaga, T., Kameya, T., Kawai, Y. & Saito, M. (2013): ‘Grains of paradise (Aframomum melegueta) extract activates brown adipose tissue and increases whole-body energy expenditure in men’. The British Journal of Nutrition, 2013 Aug;110(4):733-8. PMID: 23308394',
							'Sugita, J., Yoneshiro, T., Sugishima, Y., Ikemoto, T., Uchiwa, H., Suzuki, I. & Saito, M. (2014): ‘Daily ingestion of grains of paradise (Aframomum melegueta) extract increases whole-body energy expenditure and decreases visceral fat in humans’. Journal of Nutritional Science and Vitaminolgy, 2014;60(1):22-7. PMID 24759256',
							'Walsh, D.E., Yaghoubian, V. & Behforooz, A. (1984): ‘Effect of glucomannan on obese patients: a clinical study’. International Journal of Obesity, 1984;8(4):289-93. PMID 6096282',
							'Salas-Salvadó, J., Farrés, X., Luque, X., Narejos, S., Borrell, M., Basora, J., Anguera, J., Torres, F., Bulló, M. & Balanza, R. (2007): ‘Effect of two doses of a mixture of soluble fibres on body weight and metabolic variables in overweight or obese patients: a randomised trial’. The British Journal of Nutrition, 2008 Jun;99(6):1380-7. PMID 18031592',
						]"
					>
						{{ item }}
					</li>
				</ol>
			</div>
		</div>
	</Content>
</template>

<style>
.text-highlight {
	color: var(--text-highlight);
}

.text-color {
	color: var(--text-color);
}

.color-primary {
	color: var(--color-primary);
}

.btn-primary {
	background: var(--color-primary);
	color: var(--button-text-color);
}
</style>

<style scoped>
.content {
	--text-color: #251653;
	--text-highlight: #e7569d;
	--color-primary: #e7569d;
	--button-text-color: #ffffff;
}
</style>
